import { render, staticRenderFns } from "./KmartHeading.vue?vue&type=template&id=a044f14e&"
import script from "./KmartHeading.vue?vue&type=script&lang=js&"
export * from "./KmartHeading.vue?vue&type=script&lang=js&"
import style0 from "./KmartHeading.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports